import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'
import { background } from './sierras.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/240514/S_McLaren_heritage_{nnn} (1).png',
}

export default {
  supports360: false,
  layers: [body, background],
  resolveOptions: () => ({}),
}
